module.exports = __webpack_public_path__ + "static/img/far2_active.82b01f76.png";